import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorDO } from '../../../BaseFramework/shared/models/error.model';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  ClientService,
  AppMetadataHandler
} from 'app'
import { PolicyService } from '../../../FunctionalModules/PolicyIssuance/policy.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-insured-details',
  templateUrl: './insured-details.component.html',
  styleUrls: ['./insured-details.component.scss']
})
export class InsuredDetailsComponent implements OnInit {
  _currentComponentName = 'InsuredDetailsComponent'

  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    private clientService: ClientService,
    private policyService: PolicyService,
    public appMetadataHandler: AppMetadataHandler
  ) { }

  //Declaraions which might need developer input

  lookupsToBind = []
  selectorOfThisComponent = 'app-claims-basic-details'
  parentEvent$

  radioValue: any;
  selectedClient: any;

  /**
   *
   *  Ninad: Whenever any developer is creating a new Component,
   * please make sure that you copy all import commands, constructor and
   * Boiler and Component Creation Kickstart CODE 
   *
   * 
   * Component Creation Kickstart CODE 
   */

  //ComponentSpecific Inputs, Outputs
  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;
  private _fetchedInsuredList = [];
  @Input() set insuredList(value: any) {
    this._fetchedInsuredList = value;
    this.selectTheInsured(this._insuredInPolicy)
  }
  get insuredList() {
    return this._fetchedInsuredList || [];
  }

  _captureRoleKey = "INSURED"
  Mode = "SINGLE"
  private _insuredInPolicy = [];
  @Input()
  set inputDataForEdit(value: any) {
    if (this.Mode === 'SINGLE' && value) {
      if (value[this._captureRoleKey]) {
        this._insuredInPolicy = value[this._captureRoleKey]
      }
    }
  }
  @Input() extractRoleCd: any


  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): string {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  fetchClient$
  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      let selectedInsured = this.insuredList.find(item => item['selected'])
      if (selectedInsured && selectedInsured.id) {
        if (this.fetchClient$ != null) this.fetchClient$.unsubscribe()
        this.fetchClient$ = this.clientService.getClientById(selectedInsured.id).pipe(take(1))
          .subscribe(resp => {
            let client = { selectedClientData: [selectedInsured], fetchedClientData: [this.commonUtilty.deepCopy(resp)] }
            let output = { role: this._captureRoleKey, clientList: client || [] }
            this.EmitComponentOutput(output)
          },
            (error) => {
              throw " Something went wrong";
            }
          );
      }
      else {

        //TODO take Ninad's review
        let errorDO = new ErrorDO();
        errorDO.errorMsg = "Please select at least one i";
        errorDO.fieldName = "NA";
        errorDO.componentName = this.getCurrentComponentName();
        this.EmitComponentOutput(null)
      }
    })
  }

  //Initializations
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }
    this.subscribeToParentEvent()
    this.refreshInsuredList();
  }

  refreshInsuredList$ = null
  refreshInsuredList() {
    if (this.refreshInsuredList$) this.refreshInsuredList$.unsubscribe()
    this.refreshInsuredList$ = this.interactService.policyListSubject$.subscribe(res => {
      if (this.appMetadataHandler.featureFlags.enableExtractionOfInsuredFromProposalIO) {
        this.fetchInsuredClientDOsByPolicyList(res);
      }
      else {
        this.fetchInsuredsByPolicyList(res);
      }


    });
  }
  insuredList$ = null
  fetchInsuredsByPolicyList(data) {
    if (this.insuredList$) this.insuredList$.unsubscribe()
    this.insuredList$ = this.clientService.getListsOfInsuredByPolicyList(Object.assign([], data)).subscribe(resp => {
      this.insuredList = resp;
    });
  }

  insuredClientDOsList$ = null
  insuredClientDOsList = {}
  insuredClientDOList$ = null
  fetchInsuredClientDOsByPolicyList(data) {
    if (this.insuredClientDOList$) this.insuredClientDOList$.unsubscribe()
    this.insuredClientDOList$ = this.policyService.extractSpecificRolesUsingPolicyList(Object.assign([], data), this.extractRoleCd, "MULTIPLE").subscribe(resp => {
      this.insuredList = this.convertListOfClientDOsToInsuredSearchResultDOList(resp);
    });
  }

  convertClientDOToInsuredSearchResultDO(clientDO) {
    let output = {
      contactNum: this.commonUtilty.getContactNumFromClient(clientDO) || null,
      firstName: this.commonUtilty.getFirstNameFromClient(clientDO) || null,
      lastName: this.commonUtilty.getLastNameFromClient(clientDO) || null,
      genderCd: this.commonUtilty.getGenderFromClient(clientDO) || null,
      guid: clientDO['guid'] || null,
      clientNum: clientDO['clientNum'] || null,
      dateOfBirth: this.commonUtilty.getDateOfBirthFromClient(clientDO) || null,
      emailId: this.commonUtilty.getEmailFromClient(clientDO) || null,
      id: clientDO['id'] || null,
      externalClientNum: clientDO['externalClientNum'] || null,
      clientDO: this.commonUtilty.deepCopy(clientDO)
    }

    return output
  }

  clientDOsMap = {}
  convertListOfClientDOsToInsuredSearchResultDOList(clientDOs) {
    let output = []
    if (clientDOs && Array.isArray(clientDOs) && clientDOs.length > 0) {
      clientDOs.forEach(client => {
        this.clientDOsMap[client.clientNum] = this.commonUtilty.deepCopy(client)
        let convertedClientDO = this.convertClientDOToInsuredSearchResultDO(client)
        output.push(convertedClientDO)
      })

    }
    return output
  }

  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      // dateString = moment(rawDate).format('DD MMM YYYY HH:mm:ss');
      dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }



  handleChange(event, clientId) {
    this.clientService.getClientById(clientId)
      .subscribe(resp => {
        this.selectedClient = this.commonUtilty.deepCopy(resp);
        //
      },
        (error) => {
          throw " Something went wrong";
        }
      );
  }

  selectTheInsured(claimInsured) {
    claimInsured.forEach(claimInsuredItem => {
      this.insuredList.forEach(policyInsured => {
        if (policyInsured.id == claimInsuredItem.id) {
          policyInsured['selected'] = true
        }
      });
    });
  }

  deselectOtherClients(data) {
    // this.interactService.sendSelectedInsured(data); // old cold
    this.interactService.sendSelectedInsuredClientDO(this.clientDOsMap[data.clientNum]);
    let attrName = 'selected'
    if (data[attrName]) {
      this.insuredList.forEach(element => {
        if (data.id != element.id) element[attrName] = false
      });
    }

  }
}
